<app-blocks-workflow [blocks]="blocks" [models]="data" [context]="context" (workflowComplete)="onWorkflowComplete($event)"></app-blocks-workflow>
